<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-card tm-mb-info-card">
    <v-row no-gutters class="com-mb-card-contents-none-border pl-4 py-2">
      <v-col class="rp-twninfo ">{{ address }}</v-col>
      <div class="rp-btn ">
        <v-btn
          outlined
          x-small
          color="success"
          class="rp-btn mr-2"
          @click="openTwninfo"
        >
          <span>{{ text.btn }}</span>
        </v-btn>
      </div>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 PC用登録地点情報画面 市町村情報カード
 * RpTwninfo.vue
 * @author LIS
 */
import WebStorage from "../../lib/webStorage.js";

export default {
  name: "rp-twninfo",
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "市町村情報",
        btn: "市町村情報を表示",
      },
      twninfoUrl: "/twninfo",
      prefCd: "",
      twnCd: "",
    };
  },
  props: {
    point: { type: Number, default: 0 },
  },
  mounted() {
    let info = WebStorage.getPointInfo(this.point);
    if (info != null && info.pointIndex != null) {
      this.prefCd = info.prefCd;
      this.twnCd = info.twnCd;
    }
  },
  computed: {
    /** 住所 */
    address() {
      let info = WebStorage.getPointInfo(this.point);
      // 地点が登録されているか判定
      if (info != null && info.pointIndex != null) {
        return info.address;
      }
      return this.$store.state.app.config.messageConfig.rpNoRegist;
    },
    /** URL */
    urls: {
      get() {
        return this.$store.state.app.config.appConfig.linkUrls;
      },
    },
  },
  methods: {
    /** 市町村情報を表示 */
    openTwninfo() {
      window.open(
        this.urls.sitemap +
          this.twninfoUrl +
          "?prefCd=" +
          this.prefCd +
          "&twnCd=" +
          this.twnCd,
        "_self"
      );
    },
    /** webストレージ読込 */
    readWebStorage() {
      let info = WebStorage.getPointInfo(this.point);
      if (info != null && info.pointIndex != null) {
        this.prefCd = info.prefCd;
        this.twnCd = info.twnCd;
      }
    },
  },
  watch: {
    // 選択登録地点を監視
    point() {
      this.readWebStorage();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.com-mb-card-title {
  font-size: 1.2em;
  font-weight: bolder;
  color: black;
}
.tm-no-eva {
  font-size: 8pt;
}
.mb-issue-radius {
  border-radius: 4px;
  display: inline-block;
  padding: 0em 0.2em;
}
.margin-clear {
  margin-left: 0;
}
</style>
